import { decompressFromEncodedURIComponent } from 'lz-string';

export const decompressURLSearchParams = (searchParams: string) => {
  if (searchParams[0] === '?') {
    return decompressFromEncodedURIComponent(searchParams.slice(1));
  }

  return decompressFromEncodedURIComponent(searchParams);
};
